<template>
  <div>
    <v-container>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <h1>
            {{ $t('audience_management') }}
          </h1>
        </v-flex>
        <v-flex xs12 sm6 style="display: flex; justify-content: flex-end" class="pt-4">
          <div class="default-input text-xs-right">
            <v-text-field
              id="search"
              v-model="search"
              name="search"
              single-line
              :placeholder="$t('Search')"
              outline
              clearable
              prepend-inner-icon="search"
              hide-details
              style="max-width: 300px"
              @blur="onSearch"
              @keydown.enter="onSearch"
              @input="onSearch"
            ></v-text-field>
          </div>
        </v-flex>
      </v-layout>

      <v-data-table
        hide-actions
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        class="elevation-1 mt-3"
      >
        <template #items="props">
          <tr>
            <td class="text-xs-center">{{ props.item.audience_name }}</td>
            <td class="text-xs-right">
              <v-btn flat icon small color="primary" @click="handleDelete(props.item.id)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          v-model="pageNumber"
          :total-visible="6"
          :length="pageLength"
          @input="handleChangePage"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import bbqApi from '@/api/bbq'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
export default {
  data() {
    return {
      search: '',
      headers: [
        {
          value: 'audience_name',
          text: this.$t('name'),
          align: 'center',
          sortable: false
        },
        {
          value: '',
          text: '',
          sortable: false
        }
      ],
      items: [],
      limit: 10,
      offset: 0,
      pagetmp: 1,
      pageNumber: 1,
      total: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      loading: true,
      updateSearchTimeout: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    onSearch() {
      const vm = this
      if (vm.updateSearchTimeout) {
        clearTimeout(vm.updateSearchTimeout)
      }

      vm.updateSearchTimeout = setTimeout(async () => {
        vm.$store.dispatch('loading')
        try {
          vm.handleFetchData()
        } catch (error) {
          console.error(error)
        }
        vm.$store.dispatch('loading')
        vm.updateSearchTimeout = null
      }, 1500)
    },
    async handleFetchData() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: vm.limit,
          offset: vm.offset
        }

        if (vm.search) {
          Object.assign(data, { search: vm.search })
        }
        vm.$store.dispatch('loading')
        const response = await vm.getAudienceList(data)
        vm.$store.dispatch('loading')

        if (response && response.data.data) {
          vm.items = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async getAudienceList(data) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await bbqApi.getAudienceList({
          config: data
        })
        vm.$store.dispatch('loading')
        handleResponse(response)
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
        return null
      }
    },
    async handleDelete(id) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deleteAudience(id)
          vm.$store.dispatch('loading')
          if (response && response.status == 200) {
            vm.$swal.fire({
              type: 'success',
              title: vm.$t('Success')
            })
          }
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    },
    async deleteAudience(id) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await bbqApi.deleteAudience({
          config: {
            page_id: vm.selectedBot.pageid,
            id
          }
        })
        vm.$store.dispatch('loading')
        handleResponse(response)
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
        return null
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleFetchData()
      }
    },
    handleReset() {
      this.offset = 0
      this.handleFetchData()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/GroupAudience.vue